import { cx } from "shared/utils";
import { InfoTooltip } from "../InfoTooltip";
import type { FC, PropsWithChildren } from "react";
import { SVGComponentProps } from "untitledui-js-base";
import { Card } from "shared/components/Card";

interface Props {
  title: string;
  Icon?: FC<SVGComponentProps>;
  disabled?: boolean;
  tooltip?: string;
}

export const SettingCard: FC<PropsWithChildren<Props>> = (props) => {
  const { title, children, Icon, disabled, tooltip } = props;

  return (
    <Card
      className={cx("py-6 bg-background-1000", disabled ? "opacity-40" : "")}
    >
      <div className="flex items-center gap-4 font-bold text-base pb-6 px-8 border-b border-alpha-40">
        {Icon ? <Icon size="24" className="stroke-content-400" /> : null}
        {title}
        {tooltip && <InfoTooltip text={tooltip} />}
      </div>
      <div className="pt-4 px-8">{children}</div>
    </Card>
  );
};
